// @ts-strict-ignore
import { MBIconV2Name } from '@shared/components/image';
import { FieldOption } from './FieldOption';

export class FileFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<MBAPI.WorkflowTemplate_components_FileComponent>,
  ) {}

  matchesComponent(
    component: MBAPI.WorkflowTemplate_components,
    reservedIds: Array<string>,
  ): boolean {
    const isReserved = !!reservedIds.find(id => id === component.id);
    if (component.type !== 'FILE' || isReserved) {
      return false;
    }

    const hasContentTypes =
      !!(component as MBAPI.WorkflowTemplate_components_FileComponent).acceptedContentTypes &&
      !!this.component.acceptedContentTypes;

    if (hasContentTypes) {
      return (
        this.component.acceptedContentTypes[0] === 'image/*' &&
        (component as MBAPI.WorkflowTemplate_components_FileComponent).acceptedContentTypes[0] ===
          'image/*'
      );
    } else {
      return (
        !!(component as MBAPI.WorkflowTemplate_components_FileComponent).acceptedContentTypes ===
        !!this.component.acceptedContentTypes
      );
    }
  }

  canBeAdded(_components: MBAPI.WorkflowTemplate_components[]): boolean {
    return true;
  }
}
